import React, { useCallback, useEffect, useState } from "react";
import Dropzone from "react-dropzone-uploader";
import { Col, Form, FormGroup, Input, Label, ModalBody, ModalFooter, Row } from "reactstrap";
import { useHttpClient } from "../../../security/hooks/axiosProvider";
import ButtonComponent from "../../button-componenet/buttonComponent";
import _ from "lodash";
import styles from "./addCategory.module.scss";
import { toast } from "react-toastify";
import { translate } from "react-switch-lang";
import { CategoryDto } from "../../../models/categoryDto";
import { FileStatus } from "../../../models/fileStatus";
import { Language } from "../../../models/language";
import { IMAGE_EXTENTION } from "../../../Data/extentionImage";
import { DropZoneEventDto } from "../../../models/dropZoneEventDto";

const AddCategory: React.FC<{
  t: (key: string) => {};
  modal: boolean;
  toggle: (isOncreate: boolean) => void;
  isOnCreate: boolean;
  setBookmarklist: (listCategory: CategoryDto[]) => void;
  setListFilterCatgory: (listCategory: CategoryDto[]) => void;
  editCategoryData: CategoryDto;
  isShowDropZone: boolean;
  setIsShowDropZone: (isShowDropZone: boolean) => void;
  formValidation: boolean;
}> = props => {
  toast.configure();
  const httpClient = useHttpClient(false);
  const pathFolder = "/Mediatheque/Categories/";
  const [errorsAnglais, setErrorsAnglais] = useState<string>("");
  const [errorsFrancais, setErrorsFrancais] = useState<string>("");
  const [formValidation, setFormValidation] = useState<boolean>(false);
  const [titleFrancais, setTitleFrancais] = useState<string>("");
  const [titleAnglais, setTitleAnglais] = useState<string>("");
  const [listTypeCatgeory] = useState<string[]>([
    String(props.t("category.label_bibliotheque")),
    String(props.t("category.label_videotheque")),
    String(props.t("category.label_exhibit")),
    String(props.t("category.label_thematic_folder")),
  ]);
  const [debouncedState, setDebouncedState] = useState("");
  const [typeCategory, setTypeCategory] = useState<string>("");
  const [selectedFile, setSelectedFile] = useState<any>();
  const [urlImage, setUrlImage] = useState<string>("");
  const path = "/Mediatheque/image/";

  const handleChangeTitle = (title: string, type: string) => {
    if (title.includes("/")) {
      if (type === Language.FRANCAIS) {
        setErrorsFrancais(String(props.t("message_invalid_caractere")));
      } else {
        setErrorsAnglais(String(props.t("message_invalid_caractere")));
      }

      setFormValidation(false);
    } else {
      if (type === Language.FRANCAIS) {
        setTitleFrancais(title.trim());
        debounceFrancais(title.trim());
      } else {
        setTitleAnglais(title.trim());
        debounceAnglais(title.trim());
      }
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceFrancais = useCallback(
    _.debounce((_searchVal: string) => {
      httpClient.current?.get("/category/title", { params: { pathFolder: pathFolder + _searchVal.trim(), title: _searchVal.trim(), type: Language.FRANCAIS } }).then(response => {
        if (response.data) {
          if (!props.isOnCreate && _searchVal?.trim().toLowerCase() !== props.editCategoryData.titleFrancais?.toLowerCase()) {
            setErrorsFrancais(String(props.t("message_title_exist")));
            setFormValidation(false);
          }
          if (props.isOnCreate) {
            setErrorsFrancais(String(props.t("message_title_exist")));
            setFormValidation(false);
          }
        } else {
          if (_searchVal.trim() !== "") {
            setFormValidation(true);
            setErrorsFrancais("");
            setFormValidation(true);
          } else {
            setFormValidation(false);
          }
        }
      });
    }, 1000),
    [],
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceAnglais = useCallback(
    _.debounce((_searchVal: string) => {
      setDebouncedState(_searchVal);
      httpClient.current?.get("/category/title", { params: { pathFolder: pathFolder + _searchVal.trim(), title: _searchVal.trim(), type: "anglais" } }).then(response => {
        if (response.data) {
          if (!props.isOnCreate && _searchVal?.trim().toLowerCase() !== props.editCategoryData.titleAnglais?.toLowerCase()) {
            setErrorsAnglais(String(props.t("message_title_exist")));
            setFormValidation(false);
          }
          if (props.isOnCreate) {
            setErrorsAnglais(String(props.t("message_title_exist")));
            setFormValidation(false);
          }
        } else {
          if (_searchVal.trim() !== "") {
            setFormValidation(true);
            setErrorsAnglais("");
            setFormValidation(true);
          } else {
            setFormValidation(false);
          }
        }
      });
    }, 1000),
    [],
  );

  const handleChangeStatus = ({ meta, file }: DropZoneEventDto, status: string) => {
    if (status === FileStatus.REMOVED) {
      setSelectedFile(null);
    } else {
      if (IMAGE_EXTENTION.includes(file.name.slice(file.name.lastIndexOf(".") + 1, file.name.length).toLowerCase())) {
        if (status === FileStatus.DONE) {
          setSelectedFile(file);
          setUrlImage(meta.previewUrl);
        }
      } else {
        toast.error(String(props.t("message_extention_not_allowed")));
      }
    }
  };

  const handleSubmit = async () => {
    if (!formValidation) {
      setErrorsAnglais("Tilte cannot be empty");
    } else {
      setFormValidation(false);

      if (props.isOnCreate) {
        handleAddCategory();
      } else {
        handleUpdateCategory();
      }
    }
  };

  const handleAddCategory = () => {
    const formData = new FormData();
    formData.append("file", selectedFile);
    httpClient.current
      ?.post(`/category/files?path=${path}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(response => {
        httpClient.current
          ?.post("/category", {
            categoryId: 1,
            titleFrancais: titleFrancais,
            titleAnglais: titleAnglais,
            pathFolder: pathFolder + debouncedState,
            pathImage: response.data,
            image: "",
            lastLevel: false,
            typeCategory: typeCategory,
          })
          .then(response => {
            httpClient.current?.get("/category/child", { params: { pathFolder: pathFolder } }).then(response => {
              props.setBookmarklist(response.data);
              props.setListFilterCatgory(response.data);
              toast.success(props.t("category.message_toastr_add_category"), {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 5000,
              });
              props.toggle(false);
            });
            props.toggle(false);
          });
      });
  };

  const handleUpdateCategory = () => {
    const formData = new FormData();
    if (selectedFile) {
      formData.append("file", selectedFile);
      httpClient.current
        ?.put(`/category/files?path=${props.editCategoryData.pathImage}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(response => {
          httpClient.current
            ?.put("/category", {
              categoryId: props.editCategoryData.categoryId,
              titleFrancais: titleFrancais,
              titleAnglais: titleAnglais,
              pathFolder: props.editCategoryData.pathFolder,
              pathImage: response.data,
              image: "",
              lastLevel: false,
            })
            .then(response => {
              httpClient.current?.get("/category/child", { params: { pathFolder: pathFolder } }).then(response => {
                props.setBookmarklist(response.data);
                props.setListFilterCatgory(response.data);
                toast.success(String(props.t("message_toastr_update")), {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 5000,
                });
                props.toggle(false);
              });
            });
        });
    } else {
      if (titleFrancais !== props.editCategoryData.titleFrancais || titleAnglais !== props.editCategoryData.titleAnglais) {
        httpClient.current
          ?.put("/category", {
            categoryId: props.editCategoryData.categoryId,
            titleFrancais: titleFrancais,
            titleAnglais: titleAnglais,
            pathFolder: props.editCategoryData.pathFolder,
            pathImage: props.editCategoryData.pathImage,
            image: "",
            lastLevel: false,
          })
          .then(response => {
            httpClient.current?.get("/category/child", { params: { pathFolder: pathFolder } }).then(response => {
              props.setBookmarklist(response.data);
              props.setListFilterCatgory(response.data);
              toast.success(String(props.t("message_toastr_update")), {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 5000,
              });
              props.toggle(false);
            });
          });
      } else {
        props.toggle(false);
      }
    }
  };

  useEffect(() => {
    setFormValidation(props.formValidation);
    setTypeCategory(props.editCategoryData.typeCategory);
    setTitleAnglais(props.editCategoryData.titleAnglais);
    setTitleFrancais(props.editCategoryData.titleFrancais);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ModalBody>
        <Form className="form-bookmark needs-validation">
          <div className="form-row">
            <FormGroup className="col-md-12">
              <Label>{props.t("category.label_name_french")}*</Label>
              <div className="text-center">
                <Input
                  maxLength={100}
                  onChange={e => handleChangeTitle(e.target.value, Language.FRANCAIS)}
                  className={styles["input-name"] + " form-control"}
                  name="title"
                  type="text"
                  defaultValue={props.isOnCreate ? "" : props.editCategoryData.titleFrancais}
                  autoComplete="off"
                  placeholder={String(props.t("category.label_name_french"))}
                />
              </div>
              {errorsFrancais && <span className={styles["errors"]}>{errorsFrancais}</span>}
            </FormGroup>
            <FormGroup className="col-md-12">
              <Label>{props.t("category.label_name_anglais")}*</Label>
              <div className="text-center">
                <Input
                  maxLength={100}
                  onChange={e => handleChangeTitle(e.target.value, "anglais")}
                  className={styles["input-name"] + " form-control"}
                  name="title"
                  type="text"
                  defaultValue={props.isOnCreate ? "" : props.editCategoryData.titleAnglais}
                  autoComplete="off"
                  placeholder={String(props.t("category.label_name_anglais"))}
                />
              </div>
              {errorsAnglais && <span className={styles["errors"]}>{errorsAnglais}</span>}
            </FormGroup>
            <FormGroup className="col-md-12">
              <div className={styles["input-file-image"]}>
                <input className="form-control" name="file" accept="image/*" id="upfile" multiple type="file" />
              </div>
            </FormGroup>
            <FormGroup className="col-md-12">
              <Label>{props.t("category.label_category_type")}*</Label>
              <div className={styles["input-type-category"]}>
                <Input
                  disabled={!props.isOnCreate}
                  type="select"
                  value={props.isOnCreate ? typeCategory : props.editCategoryData.typeCategory}
                  bsSize="sm"
                  onChange={e => setTypeCategory(e.target.value)}
                >
                  <option value="">-- {props.t("category.label_category_type")} --</option>
                  {listTypeCatgeory.map((type, index) => (
                    <option value={index} key={type}>
                      {type}
                    </option>
                  ))}
                </Input>
              </div>
            </FormGroup>
            <FormGroup className="col-md-12">
              <Row>
                <Col xl="12" sm="12" md={{ size: 12, offset: 0 }}>
                  <Label id="upload">{props.t("category.label_representative_image")}*</Label>
                  {props.isShowDropZone &&
                    (!selectedFile ? (
                      <Dropzone
                        onChangeStatus={handleChangeStatus}
                        maxFiles={1}
                        accept={"image/*"}
                        multiple={false}
                        canCancel={true}
                        inputContent={
                          <div key="1">
                            <span className={styles["drop-zone-title"]}>
                              <i className="fa fa-plus"></i> {props.t("category.label_choose_image")}
                            </span>
                            <div className={styles["label-drag-and-drop"]}>{props.t("category.label_drag_and_drop_here")}</div>
                          </div>
                        }
                        styles={{
                          dropzone: { width: "90%", height: 100, background: "#efefefbf", border: "none !important" },
                          dropzoneActive: { border: "none !important" },
                        }}
                      />
                    ) : (
                      <div className="text-center">
                        <div className={styles["uploadPictureP"]}>
                          <div onClick={() => setSelectedFile(null)} className={styles["deleteImage"]}>
                            <i className="fa fa-times-circle"></i>
                          </div>

                          {selectedFile.previewUrl}
                          <img className={styles["default-image-category"]} src={urlImage} alt="" />
                        </div>
                      </div>
                    ))}
                </Col>

                {!props.isShowDropZone && (
                  <Col xl="12" sm="12" md={{ size: 4, offset: 0 }}>
                    <div className="text-center">
                      <div className={styles["uploadPictureP"]}>
                        <div onClick={() => props.setIsShowDropZone(!props.isShowDropZone)} className={styles["deleteImage"]}>
                          <i className="fa fa-times-circle"></i>
                        </div>
                        <img className={styles["default-image-category"]} src={props.editCategoryData.urlImage} alt="" />
                      </div>
                    </div>
                  </Col>
                )}
              </Row>
            </FormGroup>
          </div>
        </Form>
      </ModalBody>

      <ModalFooter>
        <ButtonComponent onClick={props.toggle} disable={false} buttonType={"button"} buttonText={String(props.t("button_cancel"))} save={false} />
        <ButtonComponent
          onClick={handleSubmit}
          disable={!formValidation || (!selectedFile && props.isShowDropZone) || !typeCategory}
          buttonType={"submit"}
          buttonText={String(props.t("button_submit"))}
          save={true}
        />
      </ModalFooter>
    </>
  );
};

export default translate(AddCategory);
